(function () {
	'use strict';

	angular
		.module('app.userlogin')
		.config(['$routeProvider', userloginRoutes]);


	userloginRoutes.$inject = ['$routeProvider'];


	function userloginRoutes($routeProvider) {

		$routeProvider.when("/cadLogin",
			{
				resolve: {
					'allPromises': ['$location', 'loginService', 'sessionService', function ($location, loginService, sessionService) {
						sessionService.setCadData().then(
							function () {
								$location.url('/login');
							}
						);
					}]
				}
			});

		$routeProvider.when("/login",
			{
				templateUrl: "app/login/login.html",
				controller: "loginController",
				controllerAs: "vm",
				resolve: {
					'allPromises': ['loginService', 'sessionService', function (loginService, sessionService) {
						console.log("loginpromise");
						var user = {};
						sessionService.setProperties(user);
						return 1;
						//return loginService.allPromises;
					}]
				}
			});

		$routeProvider.when("/main",
			{
				//templateUrl: "app/login/main.html",
				//controller: "mainController",
				//controllerAs: "vm"
				redirectTo: "/login"
			});

		$routeProvider.when("/forgotPass",
			{
				templateUrl: "reset/forgotPass.html",
				controller: "forgotPassController",
				controllerAs: "vm"
			});

		$routeProvider.when("/passReset",
			{
				templateUrl: "reset/reset.html",
				controller: "resetController",
				controllerAs: "vm"
			});

	}

})();

